<template>
    <div>
        <figure v-if="diagram" class="bg-gray-tier-2 p-4 [&_svg]:fill-none">
            <PartsBySeriesDiagram :html="diagram.svg" v-model="selectedLegendKey" />
        </figure>
        <div v-if="diagram" class="flex items-center gap-2 p-4 border-b border-gray-225 dark:border-gray-850">
            <SearchInput @input="emit('search', $event.target.value)" />
            <select v-if="finishes.length" v-model="selectedFinish" class="bg-gray-tier-2 py-1 rounded-md border-keyline-primary">
                <option :value="null">Any Finish</option>
                <option v-for="option in finishes" :value="option">{{ option }}</option>
            </select>
            <select v-if="Object.keys(diagram?.legend).length" v-model="selectedLegendKey" class="bg-gray-tier-2 py-1 rounded-md border-keyline-primary">
                <option :value="null">Any Part Type</option>
                <option v-for="(label, key) in diagram.legend" :value="key">{{ label }}</option>
            </select>
        </div>

        <LoadingSpinner v-if="isLoading" />
        <TableNew
            v-else-if="parts.length"
            name="parts-table"
            :rows="parts"
            :columns="columns"
            :sort="sort"
            row-identifier="id"
            :row-component="TableRowThree"
        />
        <div v-else class="text-center px-6 py-24">
            <p class="font-medium text-base">
                {{ $t("We haven't listed parts here yet.") }}
            </p>
            <p class="type-secondary text-sm print:hidden">
                Start a
                <button class="type-secondary underline underline-offset-4 hover:type-primary" @click="showNewMessage">
                    {{ $t('Live Chat') }}
                </button>
                to find what you need.
            </p>
        </div>
    </div>
</template>
<script setup>
import { LoadingSpinner, SearchInput, TableNew, TableProductImage, TableRowThree } from "@/Components";
import { useChat } from "@/Composables";
import { ref, watch } from "vue";
import PartsBySeriesDiagram from "@/Components/Modules/Parts/PartsBySeriesDiagram.vue";

const { showNewMessage } = useChat();
const emit = defineEmits(['search', 'filter:finish', 'filter:legend'])

const selectedFinish = ref(null)
const selectedLegendKey = ref(null)

watch(selectedFinish, (value) => emit('filter:finish', value))
watch(selectedLegendKey, (value) => emit('filter:legend', value))

const props = defineProps({
    series: {
        type: Object,
        required: true,
    },
    parts: {
        type: Array,
        required: true,
        default: () => []
    },
    finishes: {
        type: Array,
        required: true,
        default: () => []
    },
    diagram: {
        type: Object,
        default: () => null
    },
    sort: {
        type: Object,
        default: () => {}
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
})

const columns = [
    {
        name: 'SKU',
        component: TableProductImage,
        path: (row) => row,
        sortPath: 'item_id',
        props: ({ row }) => ({
            value: row,
            link: {
                name: 'web.catalog.products.show',
            },
            preview: true,
        }),
    },
    {
        name: 'Type',
        path: ({ row }) => {
            const key = row.legend_key;
            const legend = props.diagram?.legend;
            const label = legend[key] ? legend[key] : key;

            return `<span class="text-sm whitespace-nowrap">${label}</span>`;
        },
    },
]
</script>
